import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import useStyles from './InputLabel.styles';
const InputLabel = ({ className, disabled = false, error = false, children, }) => {
    const classes = useStyles();
    return (_jsx("label", Object.assign({ className: cn(className, classes.root, disabled && classes.disabled, error && classes.error) }, { children: children })));
};
export default InputLabel;
//# sourceMappingURL=InputLabel.js.map